export interface IFlexItemTimeouts {
  resize?: number
  clearSize?: number
  setNewSize?: number
  resizeChild?: number
  resizeChild2?: number
  resizeChild3?: number
}

export const clearTimeouts = (t: IFlexItemTimeouts) => {
  if (t.resize) {
    clearTimeout(t.resize)
  }
  if (t.clearSize) {
    clearTimeout(t.clearSize)
  }
  if (t.setNewSize) {
    clearTimeout(t.setNewSize)
  }
  if (t.resizeChild) {
    clearTimeout(t.resizeChild)
  }
  if (t.resizeChild2) {
    clearTimeout(t.resizeChild2)
  }
  if (t.resizeChild3) {
    clearTimeout(t.resizeChild3)
  }
}
